import { useState, useEffect } from 'react';
import axiosInstance from '../api/axiosInstance';

const baseUrl = process.env.REACT_APP_API_URL;

interface Merchant {
  id: number;
  company: string;
  industry: string;
  contactPerson: string;
  email: string;
  sourceDomain: string;
  createdAt: string;
}

const useMerchants = () => {
  const [merchants, setMerchants] = useState<Merchant[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMerchants = async () => {
      try {
        const res = await axiosInstance.get(`${baseUrl}/admin/merchant`);
        const sortedMerchants = res.data.sort(
          (a: Merchant, b: Merchant) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        setMerchants(sortedMerchants);
      } catch (error) {
        setError('Error fetching merchants');
        console.error('Error fetching merchants:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMerchants();
  }, []);

  return { merchants, loading, error };
};

export default useMerchants;
